import JSONEditor from './JSONEditor';

import './JSONEditor.scss';

export default JSONEditor;
